import { request } from "./request";

const BASE_URL = "/api/waiting-list";

export default {
  async enter(email) {
    return await request({
      method: "POST",
      url: `${BASE_URL}`,
      data: { email },
    });
  },
};
